import { getCategoryColorClass } from "@/utils/categoryColors";

interface CategoryTagProps {
  label: string;
  variant?: "colored" | "light" | "dark" | "outline" | "slate";
  size?: "sm" | "md";
  href?: string;
  className?: string;
}

/**
 * Unified category/tag badge component.
 * Replaces all scattered inline `<span className="tag-badge ...">` across the site.
 */
export default function CategoryTag({
  label,
  variant = "colored",
  size = "sm",
  href,
  className = "",
}: CategoryTagProps) {
  const sizeClass = size === "md" ? "px-3 py-1 text-sm" : "px-2.5 py-1 text-xs";

  const variantClasses: Record<string, string> = {
    colored: `tag-badge ${getCategoryColorClass(label)}`,
    light: "bg-white/90 backdrop-blur-sm rounded-full font-medium text-slate-700",
    dark: "bg-white/20 backdrop-blur-sm rounded-full font-medium text-white",
    outline: "bg-slate-50 border border-slate-100 rounded-full font-medium text-slate-600",
    slate: "bg-slate-100 rounded-full font-medium text-slate-600",
  };

  const classes = `${sizeClass} inline-flex items-center whitespace-nowrap ${variantClasses[variant]} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes}>
        {label}
      </a>
    );
  }

  return <span className={classes}>{label}</span>;
}